module.exports = __webpack_public_path__ + "img/platform3.1f16d06e.png";